<template>
     <button
     class="transition-colors duration-150 text-gray-600 bg-gray-100 border-gray-100 hover:bg-gray-200 hover:border-gray-200 focus:bg-gray-300 dark:text-white dark:bg-gray-800 dark:border-gray-800 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:bg-gray-600 px-7 py-3 first:rounded-l-lg last:rounded-r-lg disabled:bg-gray-400 disabled:dark:bg-gray-500 disabled:dark:bg-gray-950 text-sm border first:border-r-0">
          <slot/>
     </button>
</template>